import { render } from "./ServiceMatrix.vue?vue&type=template&id=536b2297&scoped=true"
import script from "./ServiceMatrix.vue?vue&type=script&lang=js"
export * from "./ServiceMatrix.vue?vue&type=script&lang=js"

import "./ServiceMatrix.vue?vue&type=style&index=0&id=536b2297&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-536b2297"]])

export default __exports__